// Module
var code = `<div class="option-master-panel">
    <div class="option-master-panel-header">
        <div class="option-master-panel-toolbar" {{^isShowToolbar}}style="display: none;" {{/}}>
            <terceraAutoHidePanel>
                <terceraInstrumentLookup isSetDefaultInstrument="false" isOptionMasterMode="true" selectedItem="{{instrument}}" mayContainTrees="true" selectedAccount="{{account}}" />
                <accountSelector selectedItem="{{.account}}" />
                <terceraButton name="infotool" terceraButtonStyle="js-button-info-option-master" SVG="true" canCheck="true" checked="{{isInfoButtonChecked}}" on-btnClick="onInfoButtonClick" />
                <terceraButton name="settings" terceraButtonStyle="js-button-settings-option-master" SVG="true" on-btnClick="onSettingsButtonClick" checked="{{isSettingsOpened}}" />
            </terceraAutoHidePanel>
        </div>
        <div class="option-master-panel-leve1">
            <terceraLevel1Panel account="{{account}}" instrument="{{underlier}}" level1Types="{{level1Types}}" level1DefaultItems="{{level1Types}}" />
        </div>
    </div>
    <div class="option-master-panel-content">
        <div class="option-master-panel-body{{isCollapsedBottom ? ' _footer-collapsed' : ' _footer-expanded'}}{{isVisibleBottom ? '' : ' _footer-empty'}}">
            <div class="option-master-panel-body-panels-container {{isShowPortfolio ? '_with-portfolio' : ''}}">
                <panelsContainerControl visiblePanelsCount="{{visiblePanelsCount}}" isVisibleTabs="{{isVisibleTopTabs}}" on-activePanelChange="onActivePanelChange" on-visiblePanelsCountChange="onVisibleTopPanelsCountChange">
                    <optionChainPanel />
                    <optionAnalyzerPanel />
                    <optionVolatilityLabPanel />
                </panelsContainerControl>
            </div>
            <div class="option-master-panel-body-portfolio" {{^.isShowPortfolio}}style="display: none;" {{/}}>
                <optionPortfolioControl/>
            </div>
        </div>
        <resizeSplitter isVisible="{{isVisibleBottom}}" minPercent="5" maxPercent="95" isHorizontal="true" activationDirection="{{splitterActivationDirection}}" isActive="{{!isCollapsedBottom}}" on-splitterResize="onSplitterResize" on-splitterActivate="onSplitterActivate" on-splitterDeactivate="onSplitterDeactivate" withIcon="true" size="4"/>
        <div class="option-master-panel-footer{{isCollapsedBottom ? ' _collapsed' : ' _expanded'}}{{isVisibleBottom ? '' : ' _empty'}}">
            <panelsContainerControl visiblePanelsCount="{{visibleBottomPanelsCount}}" isCollapsed="{{isCollapsedBottom}}" isShowCollapseButton="true" on-activePanelChange="onActivePanelChange" on-collapsedChange="onCollapsedChange" on-visiblePanelsCountChange="onVisibleBottomPanelsCountChange">
                <optionPositionsPanel />
                <optionOrdersPanel />
                <optionPaperPositionsPanel />
            </panelsContainerControl>
        </div>
    </div>
</div>`;
// Exports
export default code;